import { render, staticRenderFns } from "./UpdateSsnSlidebar.vue?vue&type=template&id=183bd2aa"
import script from "./UpdateSsnSlidebar.vue?vue&type=script&lang=js"
export * from "./UpdateSsnSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports